import { ApiResponse, RequestFailure } from '@owl-nest/api-client'
import * as api from '@owl-nest/api-client/latest'
import { PromiseAction } from '@owl-nest/redux-wrapper'
import { RootState } from '../reducers'

export enum ACTION_TYPE {
  TOGGLE_USER_STATUS = 'FANDOM.TOGGLE_USER_STATUS',
  LOAD_FANS_REQUEST = 'LOAD_FANS_REQUEST',
  LOAD_FANS_SUCCESS = 'LOAD_FANS_SUCCESS',
  LOAD_FANS_FAILURE = 'LOAD_FANS_FAILURE',
}

type ToggleUserStatus = { type: ACTION_TYPE.TOGGLE_USER_STATUS; isFollowing: boolean }

export function toggleUserFollowingStatus(isFollowing: boolean): ToggleUserStatus {
  return {
    type: ACTION_TYPE.TOGGLE_USER_STATUS,
    isFollowing,
  }
}

type LoadFanFailure = { type: ACTION_TYPE.LOAD_FANS_FAILURE; failure: RequestFailure }
type LoadFanRequest = { type: ACTION_TYPE.LOAD_FANS_REQUEST }
type LoadFanSuccess = {
  type: ACTION_TYPE.LOAD_FANS_SUCCESS
  success: api.Pageable<api.FanList<'labels'>> & { forceClean: boolean }
}

type LoadConfig<EXTRA_FIELDS extends string> = {
  pagination?: string
  extraFields?: EXTRA_FIELDS[]
  forceClean?: boolean
}

export function loadProjectFans<EXTRA_FIELDS extends string>(
  projectId: number,
  { pagination = undefined, extraFields = [], forceClean = false }: LoadConfig<EXTRA_FIELDS> = {},
): PromiseAction<RootState, ApiResponse<api.Pageable<api.FanList<EXTRA_FIELDS>> & { forceClean: boolean }>> {
  const search = new URLSearchParams(pagination)
  search.set('extra_fields', extraFields.join(','))

  return {
    types: [ACTION_TYPE.LOAD_FANS_REQUEST, ACTION_TYPE.LOAD_FANS_SUCCESS, ACTION_TYPE.LOAD_FANS_FAILURE],
    promise: async (_, state) => {
      const response = await api.api.get.projectFan({
        urlParams: { projectId: projectId.toString() },
        getParams: search,
        withToken: state.user.identity.type === 'loggedin',
      })
      return response.next(
        (success) =>
          ({ ...success.body, forceClean } as api.Pageable<api.FanList<EXTRA_FIELDS>> & { forceClean: boolean }),
      )
    },
  }
}

export type FanAction = ToggleUserStatus | LoadFanRequest | LoadFanSuccess | LoadFanFailure
